'use client';

import { useEffect, useState } from 'react';

const STORAGE_KEY = 'ladderbook.ageConfirmed.v1';

export function AgeGate(): JSX.Element | null {
  const [confirmed, setConfirmed] = useState<boolean | null>(null);

  useEffect(() => {
    try {
      setConfirmed(window.localStorage.getItem(STORAGE_KEY) === '1');
    } catch {
      setConfirmed(true);
    }
  }, []);

  if (confirmed === null || confirmed) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="age-gate-title"
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/70 p-4"
    >
      <div className="w-full max-w-md rounded-lg border border-border bg-panel p-5">
        <h2 id="age-gate-title" className="text-lg font-semibold text-text">
          Before you continue
        </h2>
        <p className="mt-2 text-sm text-muted">
          LadderBook displays public market data for informational purposes only. By continuing
          you confirm you are at least 18 years old and that viewing odds is permitted in your
          jurisdiction.
        </p>
        <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:justify-end">
          <a
            href="https://www.ncpgambling.org/help-treatment/help-by-state/"
            target="_blank"
            rel="noreferrer"
            className="text-xs text-muted hover:text-text self-center sm:mr-auto"
          >
            Problem gambling help
          </a>
          <button
            onClick={() => {
              try {
                window.localStorage.setItem(STORAGE_KEY, '1');
              } catch {
                /* ignore */
              }
              setConfirmed(true);
            }}
            className="rounded-md bg-accent text-bg px-3 py-2 text-sm font-semibold"
          >
            I am 18+ — continue
          </button>
        </div>
      </div>
    </div>
  );
}
